/*
 * Check if JWT Cookie set and then verify it
 */

import config from "../helpers/config";
import { RequestHelper } from "../helpers/requestHelper";

import { handleResponse } from "../helpers/handleResponse";

export const AttendanceService = {
  getAttendanceByOrgId,
  addAttendanceByOrgId,
  deleteAttendanceByOrgIdAndAttendanceId,
  updateAttendanceByOrgIdAndAttendanceId,
  getNoLeMissedByStudent,
};

function getAttendanceByOrgId(orgId, options = {}) {
  const requestOptions = RequestHelper.getGetRequestOptions();

  var api_url = config.api_attendance_by_orgId;
  api_url =
    RequestHelper.replaceParams(api_url, {
      orgId: orgId,
    }) + RequestHelper.formatQueryString(options);

  //return Promise.reject(new Error());
  return fetch(api_url, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data.absentees;
    });
}

function getNoLeMissedByStudent(orgId, options = {}) {
  const requestOptions = RequestHelper.getGetRequestOptions();

  var api_url = config.api_attendance_no_le_missed_by_student_by_orgId;
  api_url =
    RequestHelper.replaceParams(api_url, {
      orgId: orgId,
    }) + RequestHelper.formatQueryString(options);

  //return Promise.reject(new Error());
  return fetch(api_url, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data.noLEsMissed;
    });
}

function addAttendanceByOrgId(orgId, attendance) {
  const requestOptions = RequestHelper.getPostRequestOptions(attendance);

  var api_url = config.api_attendance_by_orgId;
  api_url = RequestHelper.replaceParams(api_url, {
    orgId: orgId,
  });
  //return Promise.reject(new Error());
  return fetch(api_url, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data.attendance;
    });
}

function updateAttendanceByOrgIdAndAttendanceId(
  orgId,
  announcementId,
  announcement
) {
  const requestOptions = RequestHelper.getPutRequestOptions(announcement);

  var api_url = config.api_announcements_by_orgId_and_announcementId;
  api_url = RequestHelper.replaceParams(api_url, {
    orgId: orgId,
    announcementId: announcementId,
  });
  //return Promise.reject(new Error());
  return fetch(api_url, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data.announcement;
    });
}

function deleteAttendanceByOrgIdAndAttendanceId(orgId, attendanceId) {
  const requestOptions = RequestHelper.getDeleteRequestOptions();

  var api_url = config.api_attendance_by_orgId_and_attendanceId;
  api_url = RequestHelper.replaceParams(api_url, {
    orgId: orgId,
    attendanceId: attendanceId,
  });

  //return Promise.reject(new Error());
  return fetch(api_url, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data._id;
    });
}
